import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    //获取单个设置的数据值
    GET_WECHAT_IS_OPEN(data) {
        controller='Setting';
        action='GetSettingValue';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取系统设置信息详情
    GET_SETTING_DETAILS(data) {
        controller='Setting';
        action='GetSettingDetails';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //修改模块操作设置
    UPDATE_SETTING(data) {
        controller='Setting';
        action='UpdateSetting';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //编辑小程序宠物分类修改
    SAVE_XCX_CATE(data) {
        controller='Setting';
        action='UpdateXcxPetCate';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    //获取小程序宠物分类修改
    GET_XCX_CATE(data) {
        controller='Setting';
        action='GetXcxPetCate';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}